import * as React from 'react';

import { IconMenu } from '../icons';

// remove nullable prop when properly implemented
interface Props {
	onClick?: () => void;
	className?: string;
}

const NavButton: React.StatelessComponent<Props> = props => {
	return (
		<button type="button" onClick={props.onClick} className={props.className}>
			<IconMenu />
		</button>
	);
};

export default NavButton;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/navigation/NavButton.tsx